import { useEffect } from "react";
import Actionbar from "src/components/common/actionbar/Authactionbar";
import { Message } from "src/components/common/form/Message";
import { useEQM1020_R01Store } from "./Store_EQM1020_R01";
import useUiuxStore from "src/store/useUiuxStore";
import { Content_EQM1020_R01 } from "./Content_EQM1020_R01";
import { SearchSection_EQM1020_R01 } from "./SearchSection_EQM1020_R01";
import { Chart_EQM1020_R01 } from "./Chart_EQM1020_R01";

/**
 * EQM1020_R01 - 설비데이타 수집 분단위 집계 조회 컨테이너 컴포넌트
 * 설비데이타 수집 분단위 집계 조회 화면의 전체 레이아웃과 상태 관리를 담당
 */
export const Container_EQM1020_R01 = () => {
    const { 
        EQM1020_R01List,
        EQM1020_R01Filter,
        initData, 
    } = useEQM1020_R01Store();
    const { setMessage } = useUiuxStore();

    // Content에서 액션바 핸들러 함수들을 가져옴
    const {
        fetchData,
        handleExcelClick,
        handleInitClick,
    } = Content_EQM1020_R01({
        setMessage,
    });

    // 1분마다 자동 조회 (실시간 모니터링)
    useEffect(() => {
        // 초기 조회
        if (EQM1020_R01Filter.baseDate) {
            fetchData();
        }

        // 1분(60000ms)마다 자동 조회
        const interval = setInterval(() => {
            if (EQM1020_R01Filter.baseDate) {
                fetchData();
            }
        }, 60000); // 1분 = 60000ms

        // cleanup 함수: 컴포넌트 언마운트 시 인터벌 제거
        return () => clearInterval(interval);
        // fetchData의 참조 변경으로 인한 중복 호출을 방지하기 위해 baseDate만 의존성에 포함 (fetchData 넣지 않기)
    }, [EQM1020_R01Filter.baseDate]);

    return (
        <div className="content-container">
            <Actionbar
                onFetchClick={fetchData}
                onSaveClick={undefined} 
                onDeleteClick={() => {}}
                onInitClick={handleInitClick}
                onExcelClick={handleExcelClick}
                onPrintClick={() => {}}
            />
            
            {/* 검색 섹션 */}
            <SearchSection_EQM1020_R01 />
            
            <div className="flex flex-1 pr-[12px] pl-[12px] pt-[2px] pb-[5px]  gap-[4px] min-h-0">
                <div className="h-full w-full">
                    {/* 차트 컴포넌트 */}
                    <Chart_EQM1020_R01 data={EQM1020_R01List} />
                </div>
            </div>
            
            {/* 메시지 표시 컴포넌트 */}
            <Message />
        </div>
    );
};
